<div class="card" role="complementary" [attr.aria-labelledby]="cardId">
  <div class="card-body">
    @if (title) {
      <h1 [id]="cardId" class="no-underline">{{ title }}</h1>
    }
    @if (subtitle) {
      <h2 class="no-underline mb-2"><strong>{{ subtitle }}</strong></h2>
    }
    <ng-content></ng-content>
  </div>
</div>
